import i18n from 'live/services/i18n'
import globalNotification from 'live/services/global-notification'
import { RawPhaseEvent, ValueUom } from '../utils/type'
import { fetchEntityEndTimestamp, fetchEntityStartTimestamp, INTERVENTION_API, RUN_API, SECTION_API } from './api'

export interface CasingValuesProps {
    prevCasingOD: ValueUom | null
    prevCasingFinalMD: ValueUom | null
    hasPreviousCasing: boolean
}

export async function fetchCasingValues(interventionId: number, sectionStart?: number): Promise<CasingValuesProps> {
    return fetch(
        `/services/plugin-static-data-manager/${SECTION_API}/getLastCasingRunAttributes?parentId=${interventionId}&sectionStart=${sectionStart}`,
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        }
    )
        .then(response =>
            response
                .json()
                .then(data => ({
                    prevCasingFinalMD: data?.prevCasingFinalMD ?? null,
                    prevCasingOD: data?.prevCasingOD ?? null,
                    hasPreviousCasing: !!(data?.prevCasingFinalMD || data?.prevCasingOD)
                }))
                .catch(() => ({
                    prevCasingFinalMD: null,
                    prevCasingOD: null,
                    hasPreviousCasing: false
                }))
        )
        .catch(() => {
            globalNotification.error(i18n(`Error getting previous casing from Tubular Type and Run.`))

            return {
                prevCasingFinalMD: null,
                prevCasingOD: null,
                hasPreviousCasing: false
            }
        })
}

export async function fetchIsWellOnshore(interventionId: number): Promise<boolean> {
    return fetch(`/services/plugin-static-data-manager/${SECTION_API}/getWellType?parentId=${interventionId}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    })
        .then(response =>
            response
                .json()
                .then(data => data?.wellType?.toUpperCase() === 'ONSHORE')
                .catch(() => false)
        )
        .catch(() => {
            globalNotification.error(i18n(`Error getting well type of section well.`))
            return false
        })
}

// PhaseModal.tsx

export interface SectionTimestamps {
    end?: number
    start?: number
}

export async function fetchSectionTimestamps(event: RawPhaseEvent): Promise<SectionTimestamps> {
    if (event.id) {
        const entityEnd = await fetchEntityEndTimestamp(event.id, SECTION_API, RUN_API)
        return { end: entityEnd || event.end }
    } else {
        const start = await fetchEntityStartTimestamp(event.intervention_id, SECTION_API, INTERVENTION_API)
        return { start: start || event.start }
    }
}
